<template>
    <div class="SC-split__col player-score__oop" v-if="matches.length > 0">
        <div class="caption">
            Next match
        </div>
        <div v-for="match in matches">
            <div class="OOP-next">

                <div class="OOP-next__inner">

                    <div class="OOP-next__player__holder">

                        <div v-for="team in match.team" class="OOP-next__player vs">

                            <div class="OOP-next__player__info__holder">

                                <div v-for="player in team.players" class="OOP-next__player__info"
                                     :data-id="player.id" v-if="player.id != 'TBD'">

                                    <img class="small-flag" :src="flagPath + player.country.toLowerCase() + '.svg'"
                                         :alt="player.country">

                                    {{ player.first }} {{ player.last }} <span
                                        class="OOP-next__player__seed" v-if="team.seed">[{{ team.seed }}]</span>

                                </div>

                                <div class="OOP-next__player__info" v-else>TBD</div>

                            </div>

                        </div>

                    </div>

                    <div class="OOP-next__link">
                        <span v-html="ico_pointer_right"></span>
                        <a :href="oop">
                            <span>View order of play</span>
                        </a>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import axios from 'axios'
    import moment from 'moment'
    import tz from 'moment-timezone'

    export default {
        props: ['type', 'player_id', 'flag', 'oop'],
        data() {
            return {
                feed: [],
                flagPath: this.flag + '/assets/dist/svg/flags/',
                matches: [],
                ico_pointer_right: window.ico_pointer_right,
            }
        },
        created() {

            let ip = this.determineFeedUrl()

            axios.get(`${ip}/get/${this.type}/oop`).then(response => {

                this.feed = response.data

                let todayAndFutureDays = this.removePastDays(response.data)
                let allMatches = this.getAllMatchesInOneArray(todayAndFutureDays)
                let playerMatches = this.getOnlyPlayerMatches(allMatches)
                let notPlayedPlayerMatches = this.getNotPlayerPlayerMatches(playerMatches)

                if ( notPlayedPlayerMatches.length > 0 ) {
                    notPlayedPlayerMatches = [notPlayedPlayerMatches[0]]
                }

                this.matches = notPlayedPlayerMatches

            }).catch(function (error) {
                console.log(error);
            });
        },
        methods: {
            removePastDays(feed) {

                return feed.filter(function (day) {
                    let date = moment(day.date).format('YYYY-MM-DD')
                    let today = moment().startOf('day').format('YYYY-MM-DD')

                    if (date >= today) {
                        return day
                    }

                })
            },
            getAllMatchesInOneArray(days) {
                let allMatches = []

                for (let day of days) {
                    for (let court of day.courts) {
                        allMatches.push(...court.matches)
                    }
                }

                return allMatches
            },
            getOnlyPlayerMatches(matches) {
                return matches.filter(function (match) {

                    if (match.team[0]['players'][0].id == this || match.team[1]['players'][0].id == this) {
                        return match
                    }

                    if (match.team[0]['players'][1]) {
                        if (match.team[0]['players'][1].id == this) {
                            return match
                        }
                    }

                    if (match.team[1]['players'][1]) {
                        if (match.team[1]['players'][1].id == this) {
                            return match
                        }
                    }

                }, this.player_id)
            },
            determineFeedUrl() {

                if (this.type == 'atp') {
                    return window.atp_ip
                } else {
                    return window.wta_ip
                }

            },
            getNotPlayerPlayerMatches(matches) {
                return matches.filter(function(match) {
                    if ( match.detail == '' ) {
                        return match
                    }
                })
            }
        }
    }
</script>